import { useParams } from "react-router-dom";
import { getFunctions } from "firebase/functions";
import { httpsCallable } from "../../../shared/legacyData/legacyCallable";
import { useSelector } from "react-redux";
import SingleClaimView from "./SingleClaimView";
import { useEffect, useState } from "react";
import UploadDocument from "../systemUtils/UploadDocument";
import { createClaimPaymentNotification } from "../../../services/notificationService";

const PayClaim = () => {
  const SEND_EMAILS = true;
  const { claimID } = useParams();
  const [claim, setExtractedData] = useState(null);
  console.log("Paying claim with ID:", claimID);
  const [paymentState, setPaymentState] = useState("inactive");

  const functions = getFunctions();

  const extract = (claim) => {
    console.log("Extracting data for claim:", claim);
    setExtractedData(claim);
  };

  const getSystemDocuments = httpsCallable(functions, "getSystemDocuments");

  const fetchClaim = async () => {
    if (claim) return claim; // Avoid refetching if already loaded
    const systemName = "claims"; // Define the system name for claims
    try {
      console.log("Fetching claims using getSystemDocuments...");
      const result = await getSystemDocuments({
        company,
        collectionBrand,
        systemName,
        auth: true, // Add auth parameter as required by the cloud function
      });
      console.log("getSystemDocuments result:", result);
      if (result.data.success) {
        const claimsData = result.data.data;
        console.log("Claims data fetched:", claimsData);
        const claimToAdjudicate = claimsData.find(
          (claim) => claim.id === claimID
        );
        console.log("Claim to adjudicate:", claimToAdjudicate);
        setExtractedData(claimToAdjudicate);
        return claimToAdjudicate;
      } else {
        console.error("Failed to fetch claims:", result.data);
      }
    } catch (error) {
      console.error("Error fetching claims: ", error);
    }
  };

  useEffect(() => {
    fetchClaim();
    console.log("The claim fetched was:", claim);
  }, []);

  const {
    email: userEmail,
    name: userName,
    userRole,
    company,
    collectionBrand,
  } = useSelector((state) => state.heroUser);

  const firestoreOperations = httpsCallable(functions, "firestoreOperations");
  const fetchFileUrl = httpsCallable(functions, "fetchFileUrl");
  const sendEmailFn = httpsCallable(functions, "sendEmail");

  const payClaim = async () => {
    setPaymentState("active");
  };

  const getReceiptUrl = async (id) => {
    const bucket = "andus-education.appspot.com";
    const storagePath = `TPC_Group/shared/receipts/${id}/receipt`;
    const url = await fetchFileUrl({
      bucketName: bucket,
      storagePath: storagePath,
    });
    const unpackedUrl = url.data.url;
    return unpackedUrl;
  };

  const onClaimPaid = async () => {
    const claim = await fetchClaim();
    console.log(claim);
    if (!claim) return;
    const htmlData = `<div style="
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      max-width: 600px;
      margin: 40px auto;
      border-radius: 12px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      background: #ffffff;
      ">

      <!-- Header -->
      <div style="
        background-color: #1e2a38;
        color: #ffffff;
        padding: 24px 28px;
        border-bottom: 4px solid #d4af37;
        text-align: center;
        ">
        <h2 style="margin: 0; font-size: 1.5rem;">A claim has been paid!</h2>
      </div>

      <!-- Body -->
      <div style="
        padding: 28px;
        color: #333333;
        font-size: 1rem;
        line-height: 1.7;
      ">
      <div>
            <p>Supplier: ${claim?.supplier || "N/A"}</p>
            <p>Invoice Number: ${claim?.invoiceNumber || "N/A"}</p>
            <p>Amount: R${claim?.totalAmount || "N/A"}</p>
            <p>To view and manage this claim, please visit the <a href="https://andus.co.za/hero-dashboard/claims/adjudicate/${
              claim?.uniqueId
            }">Claims Management Dashboard</a>.</p>


        <p style="margin-top: 40px;">
          Thanks,<br/>
          Your <strong>TPC</strong> team
        </p>

      </div>

      <!-- Footer -->
      <div style="
        background-color: #f7f7f7;
        color: #777777;
        padding: 18px 28px;
        font-size: 0.85rem;
        text-align: center;
        border-top: 1px solid #dddddd;
      ">
        This is an automated message from <strong>TPC</strong>.
      </div>

    </div>`;

    const receiptURL = await getReceiptUrl(claimID);

    const popData = `<div style="
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      max-width: 600px;
      margin: 40px auto;
      border-radius: 12px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      background: #ffffff;
      ">

      <!-- Header -->
      <div style="
        background-color: #1e2a38;
        color: #ffffff;
        padding: 24px 28px;
        border-bottom: 4px solid #d4af37;
        text-align: center;
        ">
        <h2 style="margin: 0; font-size: 1.5rem;">Proof of Payment</h2>
      </div>

      <!-- Body -->
      <div style="
        padding: 28px;
        color: #333333;
        font-size: 1rem;
        line-height: 1.7;
      ">
      <div>
      <p> A payment has been made for:</p>
            <p>Supplier: ${claim?.supplier || "N/A"}</p>
            <p>Invoice Number: ${claim?.invoiceNumber || "N/A"}</p>
            <p>Amount: R${claim?.totalAmount || "N/A"}</p>
            <p>To download the proof of payment, please click <a href="${receiptURL}">here</a>.</p>


        <p style="margin-top: 40px;">
          Thanks,<br/>
          Your <strong>TPC</strong> team
        </p>

      </div>

      <!-- Footer -->
      <div style="
        background-color: #f7f7f7;
        color: #777777;
        padding: 18px 28px;
        font-size: 0.85rem;
        text-align: center;
        border-top: 1px solid #dddddd;
      ">
        This is an automated message from <strong>TPC</strong>.
      </div>

    </div>`;

    const emailData = {
      to: `${claim.createdBy}`,
      from: "TPC Admin <noreply@mail.andus.co.za>",
      subject: "Claim has been paid",
      html: htmlData,
      isHTML: true,
    };
    if (SEND_EMAILS) {
      try {
        await sendEmailFn(emailData);
        console.log("Email sent successfully.");
      } catch (err) {
        console.error("Error sending invitation email:", err);
      }
    }

    const popEmailData = {
      to: claim?.contactEmail,
      from: "TPC Admin <noreply@mail.andus.co.za>",
      subject: "Proof of Payment - TPC",
      html: popData,
      isHTML: true,
    };

    if (SEND_EMAILS) {
      try {
        await sendEmailFn(popEmailData);
        console.log("Email sent successfully.");
      } catch (err) {
        console.error("Error sending invitation email:", err);
      }
    }

    const systemName = "claims";
    const payload = {
      operation: "update",
      company,
      collectionBrand,
      systemName,
      uniqueId: claimID,
      documentData: { ...claim, status: "PAID" },
      auth: true, // Indicate this is an authenticated request
    };

    console.log(`Calling cloud function with payload:`, payload);

    const result = await firestoreOperations(payload);
    console.log(`Claim paid successfully:`, result);

    // Create notification for claim payment
    try {
      await createClaimPaymentNotification(
        claim,
        userEmail,
        userName || userEmail.split("@")[0],
        "TPC_Group",
        "TechPerformanceCentre"
      );
      console.log("[PayClaim] ✅ Payment notification created successfully");
    } catch (notifError) {
      console.error("[PayClaim] ⚠️ Error creating notification:", notifError);
      // Don't fail the whole operation if notification fails
    }

    // window.location.replace("/hero-dashboard/claims"); // Refresh the page to reflect changes
  };

  const denyClaim = async () => {
    const firestoreOperations = httpsCallable(functions, "firestoreOperations");
    const systemName = "claims";
    const payload = {
      operation: "update",
      company,
      collectionBrand,
      systemName,
      uniqueId: claimID,
      documentData: { ...claim, status: "REJECTED" },
      auth: true, // Indicate this is an authenticated request
    };

    console.log(`Calling cloud function with payload:`, payload);

    const result = await firestoreOperations(payload);
    console.log(`Cloud function result:`, result);
    window.location.replace(`/hero-dashboard/claims`);
  };

  const stateButtonsConfig = [
    {
      state: "active",
      buttons: [
        {
          label: "Mark as Paid",
          action: payClaim,
          allowedRoles: ["CFO", "Management"],
        },
        {
          label: "Reject",
          action: denyClaim,
          allowedRoles: ["Exco, CFO"], // "Management"],
        },
      ],
    },
  ];

  const claimsSections = {
    title: "Upload Proof of Payment",
    isDocumentUpload: true,
    fields: [
      {
        name: "receipt",
        label: "Upload Proof of Payment",
        type: "file",
        accept: "application/pdf",
        required: true,
        description: "Upload a receipt document for the payment.",
      },
    ],
  };

  return (
    <div>
      {paymentState === "inactive" ? (
        <SingleClaimView
          stateButtonsConfig={stateButtonsConfig}
          claimID={claimID}
          extractDataPoints={extract}
        />
      ) : (
        <UploadDocument
          userEmail={userEmail}
          currentSection={claimsSections}
          company={company}
          collectionBrand={collectionBrand}
          systemName={"receipts"}
          uniqueId={claimID}
          dataPointDefinitions={{}}
          onSuccess={() => {
            // window.location.replace(`/hero-dashboard/claims/`);
          }}
          onDataPointsUpdate={async () => {
            await onClaimPaid();
            window.location.replace(`/hero-dashboard/claims/`);
          }}
          formData={{}}
        />
      )}
    </div>
  );
};

export default PayClaim;
